import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";
import Cookies from "js-cookie";

const parseResponse = async (res, fallback) => {
  const text = await res.text();
  const data = text ? JSON.parse(text) : fallback;
  if (!res.ok) {
    throw new Error(data?.message || `Request failed with status ${res.status}`);
  }
  return data;
};

export const generateApiKey = async (token, mantisBusinessId, name) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/api-keys/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({
      mantisBusinessId,
      name,
    }),
  });
  const data = await parseResponse(res, {});
  return data.apiKey;
};

export const listApiKeys = async (token, mantisBusinessId) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/api-keys/list`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({
      mantisBusinessId,
    }),
  });
  const data = await parseResponse(res, { apiKeys: [] });
  return data.apiKeys || [];
};

export const revokeApiKey = async (token, keyId, mantisBusinessId) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/api-keys/${keyId}/revoke`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({
      mantisBusinessId,
    }),
  });
  return parseResponse(res, {});
};

export const deleteApiKey = async (token, keyId, mantisBusinessId) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/api-keys/${keyId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({
      mantisBusinessId,
    }),
  });
  return parseResponse(res, {});
};
